import { Outlet } from 'react-router-dom'

import { EngagementSurveyOverviewPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import { useSurveyActions } from 'modules/engagement_surveys/hooks/useSurveyActions'
import NewFormEditor from 'modules/forms/components/newFormEditor'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export default function SurveyQuestionsPage() {
  const { surveyId } = useStrictParams<'surveyId'>()
  const { data, loading, error } = useQuery(EngagementSurveyOverviewPageDocument, {
    variables: { surveyId: Number(surveyId) },
  })
  const survey = data?.surveys.survey

  const { handleActionClick } = useSurveyActions()

  if (!survey) return null

  return (
    <ResponsivePage.Body
      loading={loading}
      error={error}
      variant="fullscreen"
      onActionClick={handleActionClick}
    >
      <NewFormEditor id={survey.form.id} resourceType="Surveys::Survey" formType="smart-survey" />
      <Outlet />
    </ResponsivePage.Body>
  )
}
